import { useEffect } from 'react'


const QRSelfieFan = ({ data, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])
    

    return (
        // <>
        //     <div className='SelfieFan__Screen__QR__Background'>
        //         {data.isActiveWomensMode ? (
        //             <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
        //         ) : (
        //             <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
        //         )}
        //     </div>

        //     <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'> {/* Container-FullHeight */}
        //         <div className='SelfieFan__Screen__QR__Container'>
        //             <div className='SelfieFan__Screen__QR__Container__Instructions'>
        //                 {/* <p className='SelfieFan__Screen__QR__Title' style={{ fontFamily: '"GFS Didot", serif' }}>ADSL FAN CAM</p> */}
        //                 <p className='SelfieFan__Screen__QR__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ADSL FAN CAM</p>
        //                 <img src='/img/page/adsl-five.png' className='SelfieFan__Screen__QR__Container__Instructions__Logo' />
        //                 <p className='SelfieFan__Screen__QR__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
        //             </div>
                    
        //             <img src='/img/page/qr/selfie-fan-qr-fondo-gris-con-parametros.png' className='SelfieFan__Screen__QR__Container__QR' />
        //         </div>
        //     </div>

        //     <footer className='SelfieFan__Screen__QR__Footer'>Hecho con ♥ por Interaktia | 2026</footer>
        // </>

        <>
            <div className='SelfieFan__Screen__QR__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                )}
            </div>

            <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'> {/* Container-FullHeight */}
                <div className='SelfieFan__Screen__QR__Container'>
                    <div className='SelfieFan__Screen__QR__Container__Instructions'>
                        <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen__QR__Container__Instructions__Logo' />
                        {/* <p className='SelfieFan__Screen__QR__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ADSL FAN CAM</p> */}
                        <p className='SelfieFan__Screen__QR__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
                    </div>
                    
                    {/* <img src='/img/page/qr/selfie-fan-qr-fondo-gris-con-parametros.png' className='SelfieFan__Screen__QR__Container__QR' /> */}
                    <img src='/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' />
                </div>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { QRSelfieFan };